<template>
  <v-footer v-bind="localAttrs" :padless="padless" flat class="mt-10"
    :color="$vuetify.theme.dark ? '' : 'grey lighten-3'">
    <v-container class="pa-0">

<v-list v-show="!$vuetify.breakpoint.smAndDown" subheader two-line flat class="pa-5"
        :color="'transparent'">

        <v-list-item :color="$vuetify.theme.dark ? '' : 'grey lighten-3'">
          <v-list-item-avatar>
            <v-img v-if="$vuetify.theme.dark" :src="require('../assets/companyLogoDark.png')" max-height="30" contain
              class="ma-0" />
            <v-img v-else :src="require('../assets/companyLogoLight.png')" class="ma-0" max-height="30" contain />
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-html="data.copywright"></v-list-item-title>
            <v-list-item-subtitle v-text="data.rights"></v-list-item-subtitle>

          </v-list-item-content>
          <!-- <v-spacer></v-spacer>
          <v-list-item-content>
            <v-list-item-title v-text="'To learn more, visit'"></v-list-item-title>
            <v-list-item-subtitle  >
              <v-hover v-slot="{ hover }">
                <div :style="{ 'cursor': hover ? 'pointer' : 'default' }" class="text-decoration-underline"  @click="navigateToLinkBack()">
                  <span>
                    {{ linkback.name }}
                  </span>
                    <v-icon size="15">mdi-open-in-new</v-icon>
                </div>
              </v-hover>
            </v-list-item-subtitle>
          </v-list-item-content> -->
        </v-list-item>
      </v-list>

      <!-- <div class="d-flex flex-column justify-center align-center mb-5" elevation="0">

        <span class="text-caption ">Know more at
        </span>
        <span>
          <a @click="navigateToLinkBack()" target="_blank" class="text-caption">{{ linkBack.name }}</a>
        </span>

      </div> -->
    </v-container>

  </v-footer>
</template>
<script>
export default {
  data: () => ({
    data: {
      copywright: `Copyright © ${new Date().getFullYear()} — <strong>AppBridge by Lilly.`,
      rights: ' All rights reserved.'
    },
    linkback: {
      url: process.env.VUE_APP_LINKBACK_URL,
      name: 'Enterprise Automation'
    },
    padless: true,
    variant: 'default'
  }),
  methods: {
    navigateToLinkBack () {
      window.location.href = this.linkback.url
    }
  },
  computed: {
    localAttrs () {
      const attrs = {}

      if (this.variant === 'default') {
        attrs.absolute = false
        attrs.fixed = false
      } else {
        attrs[this.variant] = true
      }
      return attrs
    }
  }
}
</script>
